import type { ReactNode } from 'react';

interface IconProps {
  className?: string;
}

export function BulkImportMobileCredentialIcon({ className }: IconProps) {
  return (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      aria-hidden
    >
      <rect
        x="6"
        y="2.5"
        width="8"
        height="15"
        rx="1.5"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <circle cx="10" cy="15.5" r="1" fill="currentColor" />
    </svg>
  );
}

export function BulkImportPinCredentialIcon({ className }: IconProps) {
  return (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      aria-hidden
    >
      <rect
        x="3.5"
        y="5.5"
        width="13"
        height="9"
        rx="1.5"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <text
        x="10"
        y="11.75"
        fill="currentColor"
        fontFamily="var(--font-family-base, system-ui, sans-serif)"
        fontSize="5.5"
        fontWeight="600"
        textAnchor="middle"
        dominantBaseline="middle"
      >
        123
      </text>
    </svg>
  );
}

export function BulkImportCardCredentialIcon({ className }: IconProps) {
  return (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      aria-hidden
    >
      <rect
        x="3"
        y="5"
        width="14"
        height="10"
        rx="1.5"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path d="M3 8.5h14" stroke="currentColor" strokeWidth="2" />
    </svg>
  );
}

interface BulkImportCredentialIconsProps {
  hasMobile?: boolean;
  hasPin?: boolean;
  cardNumber?: string;
}

export function BulkImportCredentialIcons({
  hasMobile,
  hasPin,
  cardNumber,
}: BulkImportCredentialIconsProps) {
  const hasCard = Boolean(cardNumber?.trim());
  const icons: ReactNode[] = [];

  if (hasMobile) icons.push(<BulkImportMobileCredentialIcon key="mobile" />);
  if (hasPin) icons.push(<BulkImportPinCredentialIcon key="pin" />);
  if (hasCard) icons.push(<BulkImportCardCredentialIcon key="card" />);

  if (icons.length === 0) {
    return <span className="bulk-import__credentials-empty">—</span>;
  }

  return (
    <span className="bulk-import__credentials" aria-label="Credentials">
      {icons}
    </span>
  );
}
